// SISTEMA-DE-DISENO · tono semántico del estado de un resultado.
//
// Hoy `estadoColor.js` pinta cada estado con un hex propio: Pendiente ROJO,
// Pendiente Informe AZUL, Finalizado verde, Cancelado NARANJA. Eso choca con la
// regla del sistema -- el color significa algo y es el mismo en toda la app:
//
//     gris   -> pendiente        ámbar -> en proceso
//     verde  -> completado       rojo  -> anulado / error
//
// y con "el azul es acción, no estado". Aquí sólo se traduce el nombre del
// estado al tono del sistema; los nombres, el catálogo y lo que viaja a la API
// no se tocan.
//
// `estadoColor.js` sigue existiendo intacto para `ModalResultadoExamen`, que
// todavía no está migrado: cuando lo esté, adopta esto y aquél se retira.

const MAPA_TONO = {
    pendiente: "pendiente",
    "pendiente informe": "proceso",
    finalizado: "hecho",
    cancelado: "anulado",
};

/** Nombre del estado -> tono del sistema. Lo desconocido cae en "pendiente". */
export function tonoEstadoResultado(nombre) {
    const clave = String(nombre || "").trim().toLowerCase();
    return MAPA_TONO[clave] || "pendiente";
}

export default tonoEstadoResultado;
